import { useState, type FC } from "react";
import { NavLink, Link } from "react-router-dom";
import Loader from "./Loader";
import { axiosHttpClien } from "../../utils/service";
import { toast } from "react-toastify";

interface NavItem {
    name: string;
    url: string;
}

interface NavListProps {
    title: string;
    navList: NavItem[];
    backUrl?: string;
    invalidateCache?: boolean;
}

const NavList: FC<NavListProps> = ({ title, navList, backUrl, invalidateCache }) => {
    const [loading, setLoading] = useState(false);

    const aemInvalidateCache = () => {
        setLoading(true);
        const apiInfo = {
            url: `${process.env.REACT_APP_API_BASE_URL}/abbvie-pro/aem/invalidate-cache`,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        };
        axiosHttpClien(apiInfo)
            .then((result) => {
                if (result?.data?.message) {
                    toast.success("Invalidate Cache Successfully");
                } else {
                    toast.error("Invalid Request");
                }
                setLoading(false);
            })
            .catch((err) => {
                toast.error(err.message || "Invalid Request");
            });
    };

    return (
        <>
            {loading && <Loader />}
            {backUrl && (
                <Link className="btn btn-outline-primary" to={backUrl}>
                    Back
                </Link>
            )}
            <div className="list-group mt-5">
                <div className="list-group-item list-group-item-action bg-light font-weight-bold">
                    {title}
                </div>

                {navList.map((item, index) => (
                    <NavLink
                        key={`${item.name}-${index}`}
                        className="list-group-item list-group-item-action"
                        to={item.url}
                    >
                        {item.name}
                    </NavLink>
                ))}

                {invalidateCache && (
                    <button
                        type="button"
                        className="list-group-item list-group-item-action"
                        onClick={aemInvalidateCache}
                    >
                        Invalidate Cache
                    </button>
                )}
            </div>
        </>
    );
};

export default NavList;
